export default Object.freeze({
  // LABEL_SET_DELETE: 'LABEL_SET_DELETE',
});
